<template>
    <div class="summary" v-if="lang=='fr'">
        <div class="progress">
            <h1>Votre Panier</h1>
            <div>Votre commande</div>
            <div>Facturation et livraison</div>
            <div class="active">Récapitulatif</div>
        </div>
        <div class="summary-page">
            <table class="cart-items">
                <thead>
                <tr>
                    <th>Désignation</th>
                    <th>Prix unitaire</th>
                    <th>Quantité</th>
                    <th>Prix TTC</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in items">
                    <td>{{ item.labelFR }}</td>
                    <td>{{ item.price / 100 }} €</td>
                    <td>{{ item.quantity }}</td>
                    <td> {{ subtotal(item) / 100 }} €</td>
                </tr>

                </tbody>
                <tfoot>
                <tr class="sum">
                    <td colspan="3">TOTAL TTC</td>
                    <td>{{ totalPrice / 100 }} €</td>
                </tr>
                <tr class="sum">
                    <td colspan="3">Livraison</td>
                    <td>{{ shippingCosts / 100 }} €</td>
                </tr>
                <tr class="total">
                    <td colspan="3">Total TTC à payer</td>
                    <td>{{ grandTotal / 100 }} €</td>
                </tr>
                <tr class="nobg">
                    <td colspan="3">TOTAL HT</td>
                    <td>{{ totalNoVATWithShipping / 100 }} €</td>
                </tr>
                <tr class="nobg">
                    <td colspan="3">TVA (20%)</td>
                    <td>{{ totalVATWithShipping / 100 }} €</td>
                </tr>
                <tr>
                    <td colspan="4"><button class="focus submit" @click="openCart()">Modifier votre panier</button></td>
                </tr>
                </tfoot>
            </table>

            <div class="addresses">
                <div class="billing">
                    <h3>Facturation :</h3>
                    <ul>
                        <li>{{ billingAddress.gender.fr }} {{ billingAddress.fname }} {{ billingAddress.lname }}</li>
                        <li>{{ billingAddress.address }}</li>
                        <li>{{ billingAddress.postcode }} {{ billingAddress.city }}</li>
                        <li>{{ billingAddress.country }}</li>
                        <li>Téléphone : {{ billingAddress.phone }}</li>
                        <li>{{ billingAddress.email }}</li>
                        <li><button class="focus submit" @click="openBilling()">Modifier</button></li>
                    </ul>

                </div>
                <div class="shipping">
                    <h3>Livraison :</h3>
                    <ul>
                        <li>{{ shippingAddress.gender.fr }} {{ shippingAddress.fname }} {{ shippingAddress.lname }}</li>
                        <li>{{ shippingAddress.address }}</li>
                        <li>{{ shippingAddress.postcode }} {{ shippingAddress.city }}</li>
                        <li>{{ shippingAddress.country }}</li>
                        <li>Téléphone : {{ shippingAddress.phone }}</li>
                        <li v-if="shippingAddress.observation !== ''">{{ shippingAddress.observation }}</li>
                        <li v-if="shippingAddress.is_gift > 0">C'est un cadeau</li>
                        <li v-if="shippingAddress.gift_message">Message : {{ shippingAddress.gift_message }}</li>
                        <li><button class="focus submit" @click="openShipping()">Modifier</button></li>
                    </ul>

                </div>
            </div>
            <hr/>

            <section class="actions">
                <p class="cgv">
                    J'ai lu et j'accepte les <a href="../../static/pdf/web/lesgantsdamelie_cgv.pdf" target="_blank">CONDITIONS GENERALES DE VENTE</a> <input type="checkbox" v-model="has_cgv" />
                </p>
                <button :disabled="! has_cgv" @click="nextStep()" class="next submit focus">Effectuer le paiement</button>
            </section>
        </div>
    </div>
    <div class="summary" v-else>
        <div class="progress">
            <h1>Your shopping cart</h1>
            <div>Your order</div>
            <div>Billing and Shipping Addresses</div>
            <div class="active">Summary</div>
        </div>
        <div class="summary-page">
            <table class="cart-items">
                <thead>
                <tr>
                    <th>Designation</th>
                    <th>Unit Price</th>
                    <th>Quantity</th>
                    <th>Sub-total</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in items">
                    <td>{{ item.labelEN }}</td>
                    <td>{{ item.price / 100 }} €</td>
                    <td>{{ item.quantity }}</td>
                    <td> {{ subtotal(item) / 100 }} €</td>
                </tr>

                </tbody>
                <tfoot>
                <tr class="sum">
                    <td colspan="3">TOTAL INCL. VAT</td>
                    <td>{{ totalPrice / 100 }} €</td>
                </tr>
                <tr class="sum">
                    <td colspan="3">Shipping</td>
                    <td>{{ shippingCosts / 100 }} €</td>
                </tr>
                <tr class="total">
                    <td colspan="3">Total Incl. VAT to pay</td>
                    <td>{{ grandTotal / 100 }} €</td>
                </tr>
                <tr>
                    <td colspan="3">TOTAL EXCL. VAT</td>
                    <td>{{ totalNoVATWithShipping / 100 }} €</td>
                </tr>
                <tr>
                    <td colspan="3">VAT (20%)</td>
                    <td>{{ totalVATWithShipping / 100 }} €</td>
                </tr>
                <tr>
                    <td colspan="4"><button class="focus submit" @click="openCart()">Edit your cart</button></td>
                </tr>
                </tfoot>
            </table>

            <div class="addresses">
                <div class="billing">
                    <h3>Invoice</h3>
                    <ul>
                        <li>{{ billingAddress.gender.fr }} {{ billingAddress.fname }} {{ billingAddress.lname }}</li>
                        <li>{{ billingAddress.address }}</li>
                        <li>{{ billingAddress.postcode }} {{ billingAddress.city }}</li>
                        <li>{{ billingAddress.country }}</li>
                        <li>Phone : {{ billingAddress.phone }}</li>
                        <li>{{ billingAddress.email }}</li>
                        <li><button class="focus submit" @click="openBilling()">MODIFY</button></li>
                    </ul>
                </div>
                <div class="shipping">
                    <h3>Delivery</h3>
                    <ul>
                        <li>{{ shippingAddress.gender.fr }} {{ shippingAddress.fname }} {{ shippingAddress.lname }}</li>
                        <li>{{ shippingAddress.address }}</li>
                        <li>{{ shippingAddress.postcode }} {{ shippingAddress.city }}</li>
                        <li>{{ shippingAddress.country }}</li>
                        <li>Phone : {{ shippingAddress.phone }}</li>
                        <li v-if="shippingAddress.observation !== ''">{{ shippingAddress.observation }}</li>
                        <li v-if="shippingAddress.is_gift">It's a gift</li>
                        <li><button class="focus submit" @click="openShipping()">MODIFY</button></li>
                    </ul>
                </div>
            </div>
            <hr />

            <section class="actions">
                <p class="cgv">
                    I have read and agree to the <a href="../../static/pdf/web/lesgantsdamelie_cgv.pdf" target="_blank">TERMS & CONDITIONS</a> <input type="checkbox" v-model="has_cgv" />
                </p>
                <button :disabled="! has_cgv" @click="nextStep()" class="next submit focus">PROCEED TO CHECKOUT</button>
            </section>
    </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'Summary',
    props: ['lang'],
    data() {
      return {
        has_cgv: false,
      };
    },
    computed: {
      ...mapGetters([
        'items',
        'totalNoVATWithShipping',
        'totalVATWithShipping',
        'totalPrice',
        'totalNoVAT',
        'nbItems',
        'billingAddress',
        'shippingAddress',
        'shippingCosts',
        'grandTotal',
      ]),
    },
    methods: {
      subtotal(item) {
        return item.quantity * item.price;
      },
      openCart() {
        const routes = this.$router.options.routes;
        const routeToUser = this.$router.options.getRouteByName(routes, `Checkout${this.lang.toUpperCase()}`);
        if (routeToUser) {
          this.$router.push(routeToUser);
        }
      },
      openBilling() {
        const routes = this.$router.options.routes;
        const routeToUser = this.$router.options.getRouteByName(routes, `Billing${this.lang.toUpperCase()}`);
        if (routeToUser) {
          this.$router.push(routeToUser);
        }
      },
      openShipping() {
        const routes = this.$router.options.routes;
        const routeToUser = this.$router.options.getRouteByName(routes, `Shipping${this.lang.toUpperCase()}`);
        if (routeToUser) {
          this.$router.push(routeToUser);
        }
      },
      nextStep() {
        this.$store.dispatch('validateCart', {
          billingAddress: this.billingAddress,
          shippingAddress: this.shippingAddress,
          cartItems: this.items,
          totalVAT: this.totalVATWithShipping,
          totalNoVAT: this.totalNoVATWithShipping,
          totalPrice: this.totalPrice,
          shippingCosts: this.shippingCosts,
          grandTotal: this.grandTotal,
        });
      },
      updateField(field, value) {
        this.$store.commit('updateBillingAddress', { field, value });
      },
    },
  };
</script>


<style lang="scss">
    .summary {
        padding: 2rem;
        max-width: 900px;
        background: url('../assets/checkout_bg.png') no-repeat center;
        background-size: cover;
        margin:auto;
        color: #654a45;

        .progress {
            color:white;
            counter-reset: progress-counter;

            @media (max-width:42rem) {
                padding-top:2rem;
            }

            h1 {
                color:white;
                text-transform: uppercase;
                text-shadow: 1px 1px #333;
                display: inline-block;
            }
            > div {
                display: inline-block;
                padding:.5rem 1rem;

                &.active {
                    color:#9c554b;
                }

                &:before{
                    counter-increment: progress-counter +1;
                    content: counter(progress-counter) ;
                    background-color: white;
                    color: #654a45;
                    padding:0.1rem .5rem;
                    border-radius:50%;
                    border:1px gray solid;
                    margin-right:0.5rem;
                }
            }
        }

        section.actions {
            display: block;
            height: 4rem;
            margin:1rem auto;
            .submit.next {
                float: right;
                text-transform: uppercase;
            }
            .submit.prev {
                float: left;
            }
        }

        table {
            tfoot {
                td {
                    font-weight: bold;
                }

                tr.sum td:nth-of-type(2) {padding: 0;}
                tr td:nth-of-type(2) {padding: 0;}
                tr.total {
                    text-transform: uppercase;
                    background-color: #9c554b;
                    td {
                        color:white;
                    }
                }

                tr.nobg {
                    background-color: transparent;
                }
                
                .submit {
                    float:right
                }
            }
        }

        .addresses {
            display: flex;
            @media (max-width:37.5rem) {
                flex-direction: column;
            }

            .billing, .shipping {
                flex:1;
            }

            h3, ul {
                display: inline-block;
                vertical-align: top;
            }

            ul {list-style: none}
        }
        
        .cgv {
            text-align: right;
            color: white;
            a {
                color:white;
                text-decoration: underline;
                font-weight: bold;
            }
        }

    }

</style>



// WEBPACK FOOTER //
// src/components/SummaryPage.vue